import {z} from 'zod'
import {To} from 'react-router-dom'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PageHeading} from '@/components/ui/page-atoms/PageAtoms'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {MedicalReportFieldsSchema} from '@/features/medical-reports/formSchemas'

const MedicalReportStatusSchema = MedicalReportFieldsSchema.pick({
    status: true
})
type MedicalReportStatusSchema = z.infer<typeof MedicalReportStatusSchema>

export const MedicalReportFormHeader = ({
    isFormBlocked,
    isPendingDraftSaving,
    isPendingSubmit,
    onSubmit
}: {
    isFormBlocked: boolean
    isPendingDraftSaving: boolean
    isPendingSubmit: boolean
    onSubmit: ({isDraftSaving}: {isDraftSaving: boolean}) => void
}) => {
    const {t} = useTranslation()
    const form = useFormContext<MedicalReportStatusSchema>()
    const status = useWatch({control: form.control, name: 'status'})

    return (
        <PageHeading align="center" justify="space-between">
            <h2>{t('medical_records:report_sheet')}</h2>
            <Flexbox gap={2}>
                <ButtonLink to={-1 as To} variant="ghost">
                    {t('commons:cancel')}
                </ButtonLink>
                {status == 'draft' && (
                    <Button
                        disabled={isFormBlocked || isPendingDraftSaving || isPendingSubmit}
                        onClick={() => onSubmit({isDraftSaving: true})}
                        variant="secondary"
                    >
                        {t('medical_records:save_as_draft')}
                        {isPendingDraftSaving && <Spinner />}
                    </Button>
                )}
                <Button
                    disabled={isFormBlocked || isPendingDraftSaving || isPendingSubmit}
                    onClick={() => onSubmit({isDraftSaving: false})}
                    variant="primaryNeutral"
                >
                    {t('medical_records:confirm_sign')}
                    {isPendingSubmit && <Spinner />}
                </Button>
            </Flexbox>
        </PageHeading>
    )
}
